import Axios from "../utils/axios";
import {
  IUserPreferences,
  UserPreferencesPatch,
} from "../interfaces/models/IUserPreferences";

const axios = new Axios();

const PATH = "user-preferences";

export const getUserPreferences = async (): Promise<IUserPreferences | null> => {
  try {
    const response = await axios.Get(PATH);
    const data = response?.data;
    if (data && (data.id || data.userId)) {
      return data as IUserPreferences;
    }
    return null;
  } catch (error) {
    if ((error as any)?.response?.status === 401) {
      return null;
    }
    console.error("Error fetching user preferences:", error);
    throw error;
  }
};

export const patchUserPreferences = async (
  partial: UserPreferencesPatch
): Promise<IUserPreferences> => {
  const response = await axios.PatchBody(PATH, partial);
  return response?.data as IUserPreferences;
};
